import './page'

const { Module } = Shopware

Module.register('sw-upselling-global-import', {
    type: 'plugin',
    name: 'upselling-global-import',
    title: 'sw-upselling-global-import.general.mainMenuItemGeneral',
    description: 'sw-upselling-global-import.general.description',
    color: '#ff3d58',
    icon: 'default-action-settings',

    routes: {
        index: {
            component: 'sw-upselling-global-import',
            path: 'index',
            children: {
                import: {
                    component: 'sw-upselling-global-import',
                    path: 'import'
                },
                export: {
                    component: 'sw-upselling-global-import',
                    path: 'export'
                }
            },
            redirect: {
                name: 'sw.upselling.global.import.index.import'
            }
        }
    },

    navigation: [{
        id: 'sw-upselling-global-import',
        label: 'sw-upselling-global-import.general.mainMenuItemGeneral',
        color: '#ff3d58',
        path: 'sw.upselling.global.import.index',
        icon: 'default-basic-stack-line',
        parent: 'sw-catalogue',
        position: 100
    }]
})
